import { render, staticRenderFns } from "./DichVuAmThucList.vue?vue&type=template&id=3c00d70a"
import script from "./DichVuAmThucList.vue?vue&type=script&lang=js"
export * from "./DichVuAmThucList.vue?vue&type=script&lang=js"
import style0 from "./DichVuAmThucList.vue?vue&type=style&index=0&id=3c00d70a&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports